import { AnimatePresence, motion } from 'framer-motion';

import { useBroadcast } from './hooks/useBroadcast';

import Advt from './components/Advt/Advt';
import Message from './components/Message/Message';
import { Winners } from './components/Winners/Winners';

import posterDefault from './assets/images/bgPoster.webp';
import bgDefaultVideo from './assets/video/bgVideo.webm';
import logoBig from './assets/images/logoBig.webp';

function App() {
  const { currentState, currentMessage, winnerMessages } = useBroadcast();

  return (
    <div className="app-wrapper">
      {/*чтобы не было белого фона при смене интерактивов */}
      <video
        playsInline
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        poster={posterDefault}
        style={{ zIndex: -150 }}
      >
        <source src={bgDefaultVideo} type="video/webm" />
      </video>

      <AnimatePresence mode="popLayout">
        {currentState === 'S1' && (
          <motion.div
            key={`${currentState}-message`}
            initial={{ y: 0 }}
            exit={{ y: '170%' }}
            transition={{ duration: 0.6 }}
            className="motionBlock"
          >
            <div className="messagesWrapper">
              <Message
                message={currentMessage?.message}
                rotateSign={currentMessage?.rotateSign}
              />
              <Advt currentState={currentState} />

              <motion.img
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                src={logoBig}
                alt="logoBig"
                className="logoBig"
              />

              <motion.video
                key="messageVideo"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                autoPlay="autoplay"
                muted="muted"
                loop
                id="bgVideo"
                poster={posterDefault}
              >
                <source src={bgDefaultVideo} type="video/webm"></source>
              </motion.video>
            </div>
          </motion.div>
        )}

        {currentState === 'S2' && (
          <motion.div
            key={currentState}
            className="motionBlock"
            initial={{ y: 0 }}
            exit={{ y: '170%' }}
            transition={{ duration: 0.6 }}
          >
            <Winners winnerMessages={winnerMessages} />
          </motion.div>
        )}
      </AnimatePresence>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
